import SEO_ROUTES from "../data/seo-routes.json";

/*
 * One place that decides a route's title, description, canonical and robots
 * directive — reading the SAME file scripts/seo-build.js reads, so the static
 * HTML a crawler receives and the head this sets after a client-side
 * navigation cannot disagree.
 *
 * Before this existed, seventeen pages rendered no <SEO> at all: navigating
 * from /pricing to /dashboard left "Pricing — …" in the tab and in the
 * accessibility tree. That is WCAG 2.4.2 (Page Titled) as much as it is SEO.
 */
const { site, routes, noindex } = SEO_ROUTES;

const BY_PATH = new Map(routes.map((r) => [r.path, r]));

/** Human label for a private route, so the tab is never just the brand name. */
const PRIVATE_TITLES = {
  "/login": "Sign in",
  "/register": "Create your account",
  "/forgot": "Reset your password",
  "/dashboard": "Your projects",
  "/new": "New project",
  "/settings": "Settings",
  "/teams": "Teams",
  "/admin": "Operations",
  "/billing/success": "Payment complete",
};

function isPrivate(pathname) {
  return noindex.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

export function metaForPath(pathname) {
  const exact = BY_PATH.get(pathname);
  if (exact) {
    return {
      title: exact.title,
      description: exact.description,
      canonical: site.origin + (exact.path === "/" ? "/" : exact.path),
      robots: "index, follow, max-image-preview:large, max-snippet:-1",
    };
  }

  const priv = isPrivate(pathname);
  const label = PRIVATE_TITLES[pathname];
  return {
    title: label ? `${label} — ${site.name}` : site.defaultTitle,
    description: site.defaultDescription,
    // Private pages get no canonical: pointing one at itself invites indexing
    // of a URL that can only ever render a login redirect.
    canonical: priv ? null : site.origin + pathname,
    robots: priv ? "noindex, nofollow" : "index, follow",
  };
}

export const SITE = site;
